@if (paginator.state$ | async; as paginatorState) {
	<div class="flex h-full w-full flex-col">
		<!-- The rows scroll; the footer below stays put. min-h-0 is what lets a flex child shrink
		     below its content instead of pushing the footer off the bottom. -->
		<div
			name="table-container"
			class="bg-base-100 card border-base-200 min-h-0 w-full flex-1 overflow-auto border shadow-sm"
		>
			<table
				name="table-body"
				class="table w-full"
				[class.table-xs]="denseDisplay()"
			>
				<!-- Head -->
				<thead class="bg-base-200 text-base-content/60 text-xs font-bold tracking-wider uppercase">
					<tr>
						<th class="top-0 z-50 w-12">
							<span class="text-xs font-bold">{{ numSelected() ? numSelected() : '' }}</span>
						</th>
						<th class="top-0 w-20 bg-inherit">
							<span [translate]>Preview</span>
						</th>
						<th class="top-0 bg-inherit">
							<div class="flex flex-col gap-1">
								<div class="flex items-center gap-2">
									<span [translate]>File Name</span>
									<button
										class="btn btn-ghost btn-xs btn-circle"
										(click)="paginator.setOrderingBy('public_filename')"
									>
										<span class="text-xs">⇅</span>
									</button>
									<button
										class="btn btn-ghost btn-xs btn-circle"
										(click)="toggleSearchByField('public_filename')"
									>
										<span class="text-xs">🔍</span>
									</button>
								</div>
								@if (displaySearchByFields$_['public_filename']) {
									<input
										class="input input-xs input-bordered w-full max-w-xs"
										type="text"
										[(ngModel)]="filterByFields$_['public_filename']"
										placeholder="Filter..."
									/>
								}
							</div>
						</th>
						<th class="top-0 bg-inherit">
							<div class="flex flex-col gap-1">
								<div class="flex items-center gap-2">
									<span [translate]>Type</span>
									<button
										class="btn btn-ghost btn-xs btn-circle"
										(click)="paginator.setOrderingBy('kind')"
									>
										<span class="text-xs">⇅</span>
									</button>
									<button
										class="btn btn-ghost btn-xs btn-circle"
										(click)="toggleSearchByField('kind')"
									>
										<span class="text-xs">🔍</span>
									</button>
								</div>
								@if (displaySearchByFields$_['kind']) {
									<select
										class="select select-bordered select-xs w-full max-w-xs"
										[(ngModel)]="filterByFields$_['kind']"
									>
										<option value="">All types</option>
										<option value="audio">Audio</option>
										<option value="video">Video</option>
										<option value="image">Image</option>
										<option value="document">Document</option>
										<option value="text">Text</option>
									</select>
								}
							</div>
						</th>
						<th class="top-0 bg-inherit">
							<div class="flex items-center gap-2">
								<span [translate]>Size</span>
								<button
									class="btn btn-ghost btn-xs btn-circle"
									(click)="paginator.setOrderingBy('size')"
								>
									<span class="text-xs">⇅</span>
								</button>
							</div>
						</th>
						<th class="top-0 bg-inherit">
							<div class="flex items-center gap-2">
								<span [translate]>Date</span>
								<button
									class="btn btn-ghost btn-xs btn-circle"
									(click)="paginator.setOrderingBy('time_created')"
								>
									<span class="text-xs">⇅</span>
								</button>
							</div>
						</th>
						<th class="top-0 bg-inherit"><span [translate]>Download</span></th>
						<th class="top-0 bg-inherit"><span [translate]>Actions</span></th>
					</tr>
				</thead>

				<tbody>
					@for (entityFile of paginatorState.itemsOnCurrentPage; track entityFile?.id) {
						@if (entityFile) {
							<tr
								#draggableRow
								tabindex="0"
								class="hover group cursor-pointer transition-colors"
								[class.bg-base-200]="itemsSelector.isSelected(entityFile)"
								(click)="processClick(entityFile)"
							>
								<!-- Checkbox -->
								<td>
									<!-- <label class="block h-10 w-10 bg-green-400"> -->
									<input
										type="checkbox"
										class="checkbox checkbox-sm checkbox-primary relative z-1"
										[checked]="itemsSelector.isSelected(entityFile)"
										(click)="$event.stopImmediatePropagation(); itemsSelector.toggle(entityFile)"
									/>
									<!-- </label> -->
								</td>

								<!-- Preview Thumbnail -->
								<td (click)="$event.stopImmediatePropagation(); openedItems.toggle(entityFile)">
									<lib-file-thumbnail
										[entityFile]="entityFile"
										class="h-10 w-10"
									></lib-file-thumbnail>
								</td>

								<!-- File Name -->
								<td>
									<div class="text-sm font-medium">{{ entityFile.publicFilename }}</div>
								</td>

								<!-- Kind -->
								<td>
									<div class="badge badge-sm badge-ghost">{{ entityFile.kind }}</div>
								</td>

								<!-- Size -->
								<td>
									<div class="font-mono text-xs">{{ (entityFile.size ? entityFile.size : 0) | octetHumanReadable }}</div>
								</td>

								<!-- Date -->
								<td>
									<div class="text-xs">{{ entityFile.timeCreated | date: 'shortDate' }}</div>
								</td>

								<!-- Download -->
								<td>
									<div>
										<!-- The paginator seeds placeholder rows while a page loads, whose id is the row
										     index rather than a file id. Nothing to download until the real file arrives. -->
										@if (entityFile.id?.length === 36) {
											<lib-download-button
												(click)="$event.stopImmediatePropagation()"
												[entityFileId]="entityFile.id"
											></lib-download-button>
										}
									</div>
								</td>

								<!-- Actions Menu -->
								<td>
									<button
										(click)="$event.stopImmediatePropagation()"
										[cdkMenuTriggerFor]="menu"
										class="btn btn-ghost btn-xs btn-circle"
										[attr.aria-label]="'menu' | translate | async"
									>
										<svg
											xmlns="http://www.w3.org/2000/svg"
											fill="none"
											viewBox="0 0 24 24"
											stroke-width="1.5"
											stroke="currentColor"
											class="h-5 w-5"
										>
											<path
												stroke-linecap="round"
												stroke-linejoin="round"
												d="M6.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM12.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM18.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0z"
											/>
										</svg>
									</button>

									<ng-template #menu>
										<ul
											class="menu bg-base-100 rounded-box border-base-200 text-base-content z-50 w-56 border p-2 shadow-lg"
											cdkMenu
										>
											<li>
												<button
													(click)="addToFolder(entityFile)"
													cdkMenuItem
												>
													<svg
														class="h-4 w-4"
														fill="none"
														viewBox="0 0 24 24"
														stroke="currentColor"
													>
														<path
															stroke-linecap="round"
															stroke-linejoin="round"
															stroke-width="2"
															d="M12 4v16m8-8H4"
														/>
													</svg>
													Add to folder
												</button>
											</li>
											@if (folderId()) {
												<li>
													<button
														(click)="removeFromFolder(folderId()!, entityFile)"
														cdkMenuItem
													>
														<svg
															class="h-4 w-4"
															fill="none"
															viewBox="0 0 24 24"
															stroke="currentColor"
														>
															<path
																stroke-linecap="round"
																stroke-linejoin="round"
																stroke-width="2"
																d="M20 12H4"
															/>
														</svg>
														Remove from folder
													</button>
												</li>
											}
											<li>
												<button
													(click)="renameFile(entityFile)"
													cdkMenuItem
												>
													<svg
														class="h-4 w-4"
														fill="none"
														viewBox="0 0 24 24"
														stroke="currentColor"
													>
														<path
															stroke-linecap="round"
															stroke-linejoin="round"
															stroke-width="2"
															d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
														/>
													</svg>
													Rename
												</button>
											</li>
											<li>
												<button
													class="text-error"
													(click)="deleteFile(entityFile)"
													cdkMenuItem
												>
													<svg
														class="h-4 w-4"
														fill="none"
														viewBox="0 0 24 24"
														stroke="currentColor"
													>
														<path
															stroke-linecap="round"
															stroke-linejoin="round"
															stroke-width="2"
															d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
														/>
													</svg>
													Delete
												</button>
											</li>
											<div class="divider my-0"></div>
											<li>
												<button
													(click)="openSharingDetails(entityFile)"
													cdkMenuItem
												>
													Manage Access
												</button>
											</li>
											<li>
												<button
													(click)="shareWithTeam(entityFile)"
													cdkMenuItem
												>
													Share with team
												</button>
											</li>
											<li>
												<button
													(click)="displayFileDetails(entityFile)"
													cdkMenuItem
													class="text-xs opacity-70"
												>
													ID: {{ entityFile.id | slice: 0 : 8 }}
												</button>
											</li>
											@if (shiftPressed()) {
												<li>
													<button
														(click)="refreshThumbnail(entityFile)"
														cdkMenuItem
													>
														Refresh thumbnail
													</button>
												</li>
											}
										</ul>
									</ng-template>
								</td>
							</tr>

							<!-- Expanded Preview -->
							@if (openedItems.isSelected(entityFile)) {
								<tr>
									<td
										colspan="100%"
										class="bg-base-200/50 p-6"
									>
										<div class="bg-base-100 border-base-200 relative flex w-full flex-col items-center gap-4 rounded-lg border p-6 shadow-inner">
											<button
												class="btn btn-sm btn-circle btn-ghost absolute top-2 right-2"
												(click)="openedItems.unselect(entityFile)"
											>
												✕
											</button>

											<lib-file-display [entityFile]="entityFile"></lib-file-display>
										</div>
									</td>
								</tr>
							}
						}
					} @empty {
						<tr>
							<td
								colspan="100%"
								class="py-10 text-center opacity-50"
							>
								<span [translate]>Nothing here</span>
							</td>
						</tr>
					}
				</tbody>
			</table>
		</div>

		<!-- Footer -->
		<lib-table-paginator
			[paginator]="paginator"
			[denseDisplay]="denseDisplay()"
		/>
	</div>
}
